import React from 'react';
import { cn } from '../../lib/utils';

/**
 * Primary CTA — Worldies yellow / secondary navy (not Workflow Labs orange).
 */
export default function AccentButton({
  children,
  className,
  type = 'button',
  disabled,
  onClick,
  as: Component = 'button',
  variant = 'primary',
  ...rest
}) {
  const variants = {
    primary:
      'bg-primary hover:bg-primary/90 text-ink rounded-full disabled:opacity-50 transition-transform hover:-translate-y-px',
    secondary:
      'bg-white hover:bg-paper text-ink border border-shell-border rounded-full disabled:opacity-50 transition-transform hover:-translate-y-px',
    dark:
      'bg-ink hover:bg-ink/90 text-white rounded-full disabled:opacity-50 transition-transform hover:-translate-y-px',
  };

  return (
    <Component
      type={Component === 'button' ? type : undefined}
      disabled={disabled}
      onClick={onClick}
      className={cn(
        'inline-flex items-center justify-center gap-2 text-sm font-medium px-4 py-2',
        variants[variant] || variants.primary,
        className,
      )}
      {...rest}>
      {children}
    </Component>
  );
}
